import {Tooltip, Typography} from "antd";
import {InfoOutlined} from "@ant-design/icons";
import TableRowActions from "./TableRowActions";
import FavoriteStar from "./FavoriteStar";
import Logo from "../../../../Components/Graphics/Logo";
import {PortfolioAvatars} from "../../utils";
import {formatCompanyLogoUrl} from "../../../../Api/companyApi";
import TargetAllocations from "../../../../Components/TargetAllocations";
import CopyText from "../../../../Components/Text/CopyText";
import React from "react";
import {RiPushpinFill, RiInformation2Fill} from "@remixicon/react";
import {DoubleLine} from "../../../../Components/Labels";
import {typeMap} from "../../utils";
import TimeCell from "../../../../Components/TimeCell";
const {Link} = Typography;



/**
 *
 * @param handleEdit
 * @param toggleFavorite
 * @param prefix {string, optional} if provided, is a string to prefix the portfolio name with
 * @returns {[{title: string, render: (function(*, *): JSX.Element), key: string},{title: string, render: (function(*, *)), key: string},{title: string, render: (function(*, *)), key: string},{title: string, render: (function()), key: string},{dataIndex: string, title: string, key: string},null,null,null,null,null,null,null,null,null]}
 * @constructor
 */
const TableColumnConfig = ({
                               handleEdit,
                               toggleFavorite,
                               prefix,

})=>{

    const formatPortfolioTitle = (title)=>{
        if (prefix){
            return `${prefix} ${title}`;
        }
        return title;
    }

    return [
        {
            title: <Tooltip><RiInformation2Fill size={16}/> </Tooltip>,
            key: 'action',
            render: (_, record) => (
                <TableRowActions
                    onEdit={() => handleEdit(record.id)}
                    portfolio={record}
                />
            ),
            fixed: 'left',
            width: 75
        },
        {
            title: <Tooltip title={'Pin to Favorites'}><RiPushpinFill size={16}/></Tooltip>,
            key: 'favorite',
            render: (_, record) => <FavoriteStar id={record.id} isStarred={record._user?.in_use} toggleFavorite={toggleFavorite} />,
            fixed: 'left',
            width: 75
        },
        {
            title: 'Company',
            key: 'logo',
            render: (_) => <Logo src={formatCompanyLogoUrl()} height={'55px'} width={'55px'} />,
            fixed: 'left',
            width: 100
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <Tooltip title={text}>
                    <DoubleLine
                        title={formatPortfolioTitle(text)}
                        text={typeMap?.[record?.type] ?? ''}
                        titleSize={'12px'}
                    />
                </Tooltip>
            ),
            fixed: 'left',
            className: 'dark',
            onFilter: (value, record) => record.name.toLowerCase().includes(value.toLowerCase()),
            searchable: true
        },
        {
          title: "Targets",
          dataIndex: ['targets', 'equity'],
          key: 'targets',
          render: (_, record)=> <TargetAllocations equity={record?.targets?.equity} fixed={record?.targets?.fixed} />
        },
        {
          title: 'Created',
          dataIndex: ['_meta', 'create_unix'],
          key: ['_meta', 'create_unix'],
          render: (timestamp, record) => {
            return <TimeCell timestamp={timestamp} />
          },
          sorter: (a, b) => new Date(b?._meta?.create_unix) - new Date(a?._meta?.create_unix)
        },
        {
          title: 'Updated',
          dataIndex: ['_meta', 'update_unix'],
          key: ['_meta', 'update_unix'],
          render: (timestamp, record) => {
            return <TimeCell timestamp={timestamp} />
          },
          sorter: (a, b) => new Date(b?._meta?.create_unix) - new Date(a?._meta?.create_unix)
        },
        {
          title: 'Benchmark',
          dataIndex: 'benchmark',
          key: 'benchmark',
          render: (benchmark) => {
              return <Link style={{fontSize: '14px'}}>{benchmark?.toUpperCase?.()??''}</Link>
          },
        },
        {
            title: "Tags",
            key: 'tags',
            render: (_, record)=>(<PortfolioAvatars userTags={record?.user_tags}/>),
            sorter: (a, b) => Object.keys(b?.user_tags??{}).length - Object.keys(a?.user_tags??{}).length,
        },
    ];
}

export default TableColumnConfig;